<template>
  <!-- <div
    class="c-header -flex u-bg-orange"
    :style="{
      'background-image':
        'url(' + require('@arag/assets/img/slider/slider_arag.svg') + ')',
    }"
  >
    <div class="c-header__content">
      <img src="@arag/assets/img/arag_logo.png" width="80" />
      <div class="c-header__text">
        Persönliche Unterstützung vor schweren Zahnbehandlungen.
      </div>
    </div>
    <div class="c-header__image">
      <img src="@/assets/img/slider/arag_zahn.svg" />
    </div>
  </div> -->
  <!-- <div
    class="c-header u-bg-orange -contain"
    :style="{
      'background-image':
        'url(' + require('@/assets/img/slider/arag_zahn.svg') + ')',
    }"
  >
    <img class="c-header__logo" width="40" src="@/assets/img/arag_logo.png" />
  </div> -->
  <Header
    class="u-bg-orange -contain"
    headline="Persönliche Unterstützung vor schweren Zahnbehandlungen."
    :image="require('@/assets/img/slider/arag_zahn.svg')"
    :logo="require('@/assets/img/arag_logo.png')"
    logoWidth="40"
    hideButton
  />
  <p class="ion-padding-top">
    <b>ARAG Case Management ZAHN</b>
  </p>
  <p>
    Ihr Service bei aufwendigen und schweren Zahnbehandlungen. Ob Zweitmeinung
    oder Suche eines geeigneten Zahnarztes - ein Case Manager prüft Ihr Anliegen
    und kümmert sich persönlich um eine Lösung für Sie.
  </p>
  <p>
    Er unterstützt Sie, einen geeigneten Zahnarzt oder Spezialisten zu finden
    oder organisiert für Sie eine Zweitmeinung, um Sie von Ihren Zahnschmerzen
    zu befreien und langwierigen Bahndlungen ein Ende zu setzen.
  </p>
  <ion-button
    size="small"
    fill="clear"
    class="ion-text-wrap ion-no-padding"
    @click="openKostenerstattungModal"
    >Kostenrückerstattung&nbsp;
    <ion-icon :icon="helpCircle" />
  </ion-button>
</template>

<script>
import { modalController, IonButton, IonIcon } from "@ionic/vue";
import { helpCircle } from "ionicons/icons";
import KostenerstattungModal from "@arag/components/KostenerstattungAragZahnModal";
import Header from "@/components/Header";

export default {
  components: {
    IonButton,
    IonIcon,
    Header,
  },
  props: {
    from: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
  },
  setup() {
    return {
      helpCircle,
    };
  },
};
</script>

<style></style>
